import { Container, Card, Table, Col, Row, Button, Modal, Form, Spinner, Dropdown} from "react-bootstrap";
import Layout from "../components/Layout";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getPettyBeneficaries, getPettyRequest, managePettyRequest } from "../redux/slices/account.service";
import dateFormatter from "../utils/dateFormatter";
import formatCurrency from "../utils/currencyFormmter";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RecordFilter from "../components/RecordFilter";
import Paginator from "../components/table/Paginator";
import Swal from "sweetalert2";
import { managerGetPettyRequest, managerSubmitPettyRequest } from "../redux/slices/manager.auth.slice";
import AmountInput from "../components/AmountInput";

const PettyCashRequests = () => {

    const dispatch = useDispatch()
    const isLoaded = useRef(false)
    const navigate = useNavigate();
    const { user = {} } = useSelector((state) => state.auth)


    const [state, setState] = useState({
        analytcics: {},
        results: [],
        showBeneficiaryForm: false,
        showPinForm: false,
        showPaymentForm: false,
        loading: false,
        paginationData: {},
        page: 1,
        wallet: {},
        payload: {
            status: '',
            type: '',
            reference: '',
            date: ''
        },
        errors: {},
        banks: [],
        beneficiaries: [],
        beneficiary: {},
        receipt: {},
        showReceipt: false,
        copiedText: '',
        showRequestForm: false,
        attachment_file: null,
        attachment_image: null,
    })


    useEffect(() => {
        if(!isLoaded.current) {
            loadPettyCashRequests()
            isLoaded.current =  true
        }
    }, [])

    const loadPettyCashRequests = () => {
        const action = user?.user_type === 'owner' ? getPettyRequest(state.page) :  managerGetPettyRequest()
        dispatch(action)
        .then((response) => {
            let analytcics = {}
            let results = []
            if(response.payload?.results) {
                results = response.payload.results
            }
            if(response.payload?.analytics) {
                analytcics = response.payload.analytcics
            }
            setState((prevState) => ({...prevState, analytcics: response.payload.analytcics, results: results}))
        })
    }

    const handleInput = (event) => {
        const { name, value } = event.target
        setState((prevState)=> ({...prevState, payload:{...prevState.payload, [name]: value}}))
    }

    const handleValidation = (event) => {

        const regex = /^\d*\.?\d*$/;
        const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
    
        const {name, value} = event.target
        if(value === '' && event.target.attributes.required) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }

        else if (name ==='amount' && !regex.test(parseFloat(value.replace(/[^\d.]/g, '')))) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }
        else {
            event.target.style = "border-style: transparent"
            delete state.errors[name]
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }
    }

    const handlePagination = (data) => {
        setState((prevState) => ({...prevState, page: data}))
    }

    const confirmAction = (id, option) => {
        Swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            text:  `Do you wish to procceed with this action?`,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Proceed!'
        }).then((result) => {
            if (result.isConfirmed) {
                setState((prevState) => ({...prevState, showPinForm: true, request_id: id, action: option}))
            }
        })
    }


    const manageRequest = () => {
        const requestPayload = { 
            petty_cash_request_id: state.request_id,
            pin: state.payload.pin,
            action: state.action,
        }
        setState((prevState) => ({...prevState, loading: true }))
        dispatch(managePettyRequest(requestPayload))
        .then((response) => {
            if(response?.payload?.success === true) {
                setState((prevState) => ({...prevState, showPinForm: false}))
                Swal.fire({
                    icon: 'success',
                    text: response.payload.message,
                })
                loadPettyCashRequests()
            }
            else {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: response.payload.message ?? 'An error occurred',
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false })))
    }

    const submitPettyCashRequest = () => {

        if(state.payloadamount === '' || state.payload.amount === undefined) {
            setState((prevState) => ({...prevState, errors: {...prevState.errors, amount: 'Amount is required'}}))
            return
        }
        else {
            delete state.errors['amount']
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }

        let formdata = new FormData()
        formdata.append('amount', state.payload.amount)
        formdata.append('reason', state.payload.reason)
        formdata.append('attachment', state.attachment_file)

        Swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            text: `This will submit a request of ${formatCurrency(state.payload.amount).with_currency}`,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Proceed!'
        })
        .then((result) => {
            if (result.isConfirmed) {
                setState((prevState) => ({...prevState, loading: true }))
                dispatch(managerSubmitPettyRequest(formdata))
                .then((response) => {
                    if(response?.payload?.success === true) {
                        setState((prevState) => ({...prevState, showRequestForm: false}))
                        Swal.fire({
                            icon: 'success',
                            text: response.payload.message,
                        })
                        loadPettyCashRequests()
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            text: response.payload.message,
                        })
                    }
                })
                .finally(() => setState((prevState) => ({...prevState, loading: false })))
            }
        })
    }

    const handleAmountUpdate = (data) => {
        const cleanAmount = data.split(',').join('')
        setState((prevState) => ({...prevState, payload: {...prevState.payload, amount: cleanAmount}}))
    }

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
            setState((prevState) => ({...prevState,  attachment_file: file, attachment_image: reader.result}))
        };
    }

    return (
        <Layout>
            <Container className="mt-4 px-4 mb-4">
                <Col md={12} className="row align-items-center justify-content-between flex-wrapd">
                    <div className="col-md-4">
                        <h3 className="m-0">PettyCash Requests</h3>
                        <p>
                            <small>Manage pettycash details</small>
                        </p>                        
                    </div>
                    <div className="col-md-8 text-right">
                        {
                            user?.user_type !== 'owner' && 
                            <Button 
                                type="button" 
                                variant="primary" 
                                className="border-0 mb-2 ms-2"
                                onClick={ () => setState((prevState) => ({...prevState, showRequestForm: !state.showRequestForm}))}
                            >
                                <FontAwesomeIcon icon={'sack-dollar'} />
                                <span className="ps-2">Request Cash</span>
                            </Button>
                        }
                        <Button 
                            type="button" 
                            className="border-0 mb-2 px-3 ms-2"
                            // onClick={() => confirmAction('c556e962-5fb9-4836-891b-b3dc81ad1358', 'approved')}
                            onClick={ () => user.user_type === 'owner' ? navigate('/petty-cash') : navigate('/members/petty-cash')}
                        >
                            <FontAwesomeIcon icon={'list'}/>
                            <span className="ps-2">PettyCash</span>
                        </Button>
                    </div>
                </Col>
                <Row>
                    <Col md="12 mt-4">
                        <Card className="shaow-sm border-0">
                            <Card.Body>
                                <Table size="sm" className="table-color table-stripedd">
                                <thead>
                                    <tr>
                                        <th>Requested By</th>
                                        <th>Description</th>
                                        <th>Amount</th>
                                        <th>Currency</th>
                                        <th>Request Date</th>
                                        <th>Attachment</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        state.results?.length ? (
                                            state.results?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.requested_by} </td>
                                                    <td>{item.description}</td>
                                                    <td>{formatCurrency(item.amount, item.currency).with_currency}</td>
                                                    <td>{item.currency} </td>
                                                    <td>{dateFormatter(item.date_created)} </td>
                                                    <td>
                                                        {
                                                            item.attachment && (
                                                                <a href={item.attachment} target="_blank" className="text-primary font-bold">
                                                                    <FontAwesomeIcon icon={'paperclip'} /> View
                                                                </a>
                                                            )
                                                        }
                                                    </td>
                                                    <td className="d-flex m-0 align-items-center justify-content-between">
                                                        {item.status}
                                                        {
                                                            user?.user_type === 'owner' && item.status === 'pending' ?
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" className="border-0 bg-transparent" size="sm" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                </Dropdown.Toggle>
    
                                                                <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                    <Dropdown.Item 
                                                                        eventKey={1} 
                                                                        className="text-success d-flex align-items-center gap-1" 
                                                                        onClick={() => confirmAction(item.id, 'approved')}
                                                                    >
                                                                        <FontAwesomeIcon icon={'check'} className="text-success" style={{fontSize: "20px"}}/> Approve
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Divider />
                                                                    <Dropdown.Item 
                                                                        eventKey={1} 
                                                                        className="text-danger d-flex align-items-center gap-1" 
                                                                        onClick={() => confirmAction(item.id, 'rejected')}
                                                                    >
                                                                    <FontAwesomeIcon icon={"cancel"} style={{fontSize: "20px"}} />  Reject
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown> : null
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                        : 
                                        (
                                            <tr>
                                                <td colSpan={5} className="text-center text-muted">No data found</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                            </Card.Body>
                        </Card>
                        {
                            state.results?.length ? (
                                <div className="table-responsive mt-2">
                                    <Paginator
                                        next={state.paginationData.next} 
                                        prev={state.paginationData.prev}
                                        setCurrentPage={ handlePagination }
                                    />
                                </div>
                            ) : null
                        }
                    </Col>
                </Row>

                <Modal 
                    show={state.showPinForm}
                    onHide={() => setState((prevState) => ({...prevState, showPinForm: !state.showPinForm}))}
                    backdrop="static"
                >
                    <Modal.Header closeButton className="bg-primary p-1 px-2 text-white">
                        <Modal.Title>
                            Authorize Request
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Form.Group as={Col} md={12} sm={12} xs={12} className="mb-3">
                                    <Form.Label className="mb-0">PIN</Form.Label>
                                    <Form.Control
                                        type="password"
                                        required
                                        placeholder="PIN"
                                        name="pin"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        autoComplete="off"
                                        maxLength={4}
                                        minLength={4}
                                    />
                                    {
                                        state.errors['pin'] && 
                                        <Form.Text className="text-danger">{state.errors['pin']}</Form.Text>
                                    }
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button 
                            variant="danger" 
                            className="border-0 px-4 text-white"
                            onClick={() => setState((prevState) => ({...prevState, showPinForm: !state.showPinForm}))}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="primary" 
                            className="border-0 px-4"
                            onClick={manageRequest}
                        >
                            Submit <Spinner animation="border" size="sm" className={state.loading ? 'd-inline-block ms-2' : 'd-none'} />
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Request Cash */}
                <Modal 
                    show={state.showRequestForm}
                    onHide={() => setState((prevState) => ({...prevState, showRequestForm: !state.showRequestForm}))}
                    backdrop="static"
                >
                    <Modal.Header closeButton className="bg-primary p-1 px-2 text-white">
                        <Modal.Title>
                            Request Petty Cash
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Form.Group as={Col} md={12} lg={12} sm={12} className="mb-3">
                                    <Form.Label className="mb-0">Amount</Form.Label>
                                    <AmountInput onChange={handleAmountUpdate} />
                                    {
                                        state.errors['amount'] && 
                                        <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} sm={12} xs={12} className="mb-3">
                                    <Form.Label className="mb-0">Reason</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        placeholder="Reason"
                                        name="reason"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        autoComplete="off"
                                    />
                                    {
                                        state.errors['reason'] && 
                                        <Form.Text className="text-danger">{state.errors['reason']}</Form.Text>
                                    }
                                </Form.Group>
                                <Form.Group as={Col} md={12} sm={12} className="mb-3">
                                    <span>Attach file</span><span className="text-danger">*</span>
                                    <Form.Control
                                        type="file"
                                        onChange={handleFileSelect}
                                        name="image"
                                        accept="image/*"
                                    />
                                    <div className="mt-2 mb-2">
                                        {
                                            state.attachment_image ? (
                                                <img
                                                    src={state.attachment_image}
                                                    alt="Image"
                                                    width="100"
                                                    height="100"
                                                    className="img-thumbnail"
                                                />
                                            ) : null
                                        }
                                    </div>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button 
                            variant="danger" 
                            className="border-0 px-4 text-white"
                            onClick={() => setState((prevState) => ({...prevState, showRequestForm: !state.showRequestForm}))}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="primary" 
                            className="border-0 px-4"
                            onClick={submitPettyCashRequest}
                        >
                            Submit <Spinner animation="border" size="sm" className={state.loading ? 'd-inline-block ms-2' : 'd-none'} />
                        </Button>
                    </Modal.Footer>
                </Modal>

            </Container>
        </Layout>
    );
}

export default PettyCashRequests;